"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _I18n = _interopRequireDefault(require("I18n"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _immutable = require("immutable");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _TimePickerButton = _interopRequireDefault(require("MeetingsLib/components/schedule/time/TimePickerButton"));

var _TimezoneSelect = _interopRequireDefault(require("MeetingsLib/components/schedule/time/TimezoneSelect"));

var _ZeroState = _interopRequireDefault(require("MeetingsLib/components/schedule/ZeroState"));

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _AvailabilitySelectors = require("MeetingsLib/selectors/AvailabilitySelectors");

var _RequestStatusSelectors = require("MeetingsLib/selectors/RequestStatusSelectors");

var _TroubleshootingSelectors = require("MeetingsLib/selectors/TroubleshootingSelectors");

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var FormActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/FormActions"));

var _isEmpty = _interopRequireDefault(require("transmute/isEmpty"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var TimePicker = (0, _createReactClass.default)({
  displayName: "TimePicker",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    // passed
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    compact: _propTypes.default.bool,
    profile: _propTypes.default.instanceOf(_UserProfile.default).isRequired,
    // loaded
    availableStartTimeOptions: _propTypes.default.instanceOf(_immutable.List).isRequired,
    duration: _propTypes.default.number,
    selectedTime: _propTypes.default.number,
    setEventDateTime: _propTypes.default.func.isRequired,
    setTimezone: _propTypes.default.func.isRequired,
    troubleshootStartTimes: _propTypes.default.instanceOf(_immutable.List).isRequired,
    userTimezone: _propTypes.default.string.isRequired,
    isTroubleshooting: _propTypes.default.bool.isRequired,
    TimePickerMarker: _propTypes.default.func.isRequired,
    selectedDate: _propTypes.default.string
  },
  getClassNames: function getClassNames() {
    var compact = this.props.compact;
    return (0, _classnames.default)('time-picker width-100', {
      compact: compact,
      'm-y-8': !compact,
      'm-top-8 m-bottom-13': compact
    });
  },
  getTimeRangeValueLabel: function getTimeRangeValueLabel(time) {
    var userTimezone = this.props.userTimezone;
    return _I18n.default.moment(time).tz(userTimezone).format('LT');
  },
  handleSetEventDateTime: function handleSetEventDateTime(time) {
    var setEventDateTime = this.props.setEventDateTime;
    return this.partial(setEventDateTime, time);
  },
  shouldShowNoTimesMessage: function shouldShowNoTimesMessage() {
    var _this$props = this.props,
        availableStartTimeOptions = _this$props.availableStartTimeOptions,
        isTroubleshooting = _this$props.isTroubleshooting,
        troubleshootStartTimes = _this$props.troubleshootStartTimes;

    if (isTroubleshooting) {
      return (0, _isEmpty.default)(troubleshootStartTimes);
    }

    return availableStartTimeOptions.count() === 0;
  },
  renderTroubleshootTimeButtons: function renderTroubleshootTimeButtons() {
    var _this = this;

    var _this$props2 = this.props,
        branding = _this$props2.branding,
        selectedTime = _this$props2.selectedTime,
        troubleshootStartTimes = _this$props2.troubleshootStartTimes,
        userTimezone = _this$props2.userTimezone,
        selectedDate = _this$props2.selectedDate;
    return troubleshootStartTimes.map(function (troubleshootStartTime) {
      var _troubleshootStartTim = (0, _slicedToArray2.default)(troubleshootStartTime.conflictingEvents, 1),
          _troubleshootStartTim2 = _troubleshootStartTim[0],
          conflictingEvent = _troubleshootStartTim2 === void 0 ? {} : _troubleshootStartTim2;

      return _react.default.createElement(_TimePickerButton.default, {
        key: troubleshootStartTime.startMillisUtc,
        branding: branding,
        disabled: !troubleshootStartTime.available,
        selectedTime: selectedTime,
        time: troubleshootStartTime.startMillisUtc,
        unavailableReason: troubleshootStartTime.reason,
        userTimezone: userTimezone,
        handleSetEventDateTime: _this.handleSetEventDateTime(troubleshootStartTime.startMillisUtc),
        conflictingEvent: conflictingEvent,
        selectedDate: selectedDate
      });
    });
  },
  renderTimePickerButtons: function renderTimePickerButtons() {
    var _this2 = this;

    var _this$props3 = this.props,
        availableStartTimeOptions = _this$props3.availableStartTimeOptions,
        selectedTime = _this$props3.selectedTime,
        userTimezone = _this$props3.userTimezone,
        branding = _this$props3.branding,
        selectedDate = _this$props3.selectedDate;
    return availableStartTimeOptions.sort().map(function (time) {
      return _react.default.createElement(_TimePickerButton.default, {
        key: time,
        disabled: false,
        branding: branding,
        handleSetEventDateTime: _this2.handleSetEventDateTime(time),
        selectedTime: selectedTime,
        time: time,
        userTimezone: userTimezone,
        selectedDate: selectedDate
      });
    });
  },
  renderInputs: function renderInputs() {
    var _this$props4 = this.props,
        isTroubleshooting = _this$props4.isTroubleshooting,
        TimePickerMarker = _this$props4.TimePickerMarker,
        availableStartTimeOptions = _this$props4.availableStartTimeOptions;
    var buttons = isTroubleshooting ? this.renderTroubleshootTimeButtons() : this.renderTimePickerButtons();
    var sortedTimes = availableStartTimeOptions.sort();
    var maxVal = this.getTimeRangeValueLabel(sortedTimes.last());
    var minVal = this.getTimeRangeValueLabel(sortedTimes.first());
    return _react.default.createElement("div", {
      role: "region",
      "aria-labelledby": "available-times",
      id: "available-times-region",
      "aria-controls": "meeting-confirmation-form",
      className: "time-list-container p-x-1 overflow-y-auto",
      "aria-valuemax": maxVal,
      "aria-valuemin": minVal
    }, buttons, _react.default.createElement(TimePickerMarker, null));
  },
  renderTimezoneSelect: function renderTimezoneSelect() {
    var _this$props5 = this.props,
        setTimezone = _this$props5.setTimezone,
        userTimezone = _this$props5.userTimezone,
        branding = _this$props5.branding;
    return _react.default.createElement(_TimezoneSelect.default, {
      style: {
        width: 'auto'
      },
      setTimezone: setTimezone,
      userTimezone: userTimezone,
      branding: branding,
      placement: "bottom"
    });
  },
  render: function render() {
    var _this$props6 = this.props,
        duration = _this$props6.duration,
        profile = _this$props6.profile,
        TimePickerMarker = _this$props6.TimePickerMarker;

    if (!duration) {
      return null;
    }

    if (this.shouldShowNoTimesMessage()) {
      return _react.default.createElement("div", {
        className: "align-center height-100"
      }, _react.default.createElement(_ZeroState.default, {
        profile: profile,
        TimePickerMarker: TimePickerMarker
      }));
    }

    return _react.default.createElement("div", {
      className: this.getClassNames()
    }, _react.default.createElement(_H.default, {
      "aria-level": 2,
      className: "m-bottom-1",
      id: "available-times"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "prebook.timePicker.header"
    })), this.renderTimezoneSelect(), this.renderInputs());
  }
});

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    // Rerenders component in response to translation
    activeLocale: state.activeLocale,
    troubleshootStartTimes: (0, _TroubleshootingSelectors.getTroubleshootStartTimesForSelectedDate)(state),
    isTroubleshooting: (0, _TroubleshootingSelectors.isTroubleshootingSelector)(state),
    availableStartTimeOptions: (0, _AvailabilitySelectors.getAvailableStartTimesForSelectedDate)(state),
    duration: (0, _BookInfoSelectors.getEvent)(state).duration,
    isFetchingPublicAvailability: (0, _RequestStatusSelectors.getIsFetchingPublicAvailability)(state),
    selectedTime: (0, _BookInfoSelectors.getEvent)(state).dateTime,
    selectedDate: (0, _BookInfoSelectors.getEvent)(state).dateString,
    userTimezone: state.userTimezone
  };
}, Object.assign({}, FormActions))(TimePicker);

exports.default = _default;
module.exports = exports.default;